import React from 'react';
import { getCurrentPageId } from 'app/stores/selectors';
import { useConnect } from 'app/views/hooks/useConnect';
import { ProjectPageContent } from './PageContent';
export const Project = () => {
    const { virtualRect, pageId } = useConnect(state => ({
        virtualRect: state.viewport.virtual,
        pageId: getCurrentPageId(state),
    }));
    if (!virtualRect || !pageId) {
        return null;
    }
    return (React.createElement(ProjectPageContent, { pageId: pageId, viewBox: virtualRect, hideWatermark: configGet('hideWatermarkDuringRollout', false) }));
};
